import watchFeatureToggle from './featureToggle'

export default watchFeatureToggle
